import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  LinearProgress,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';
import { changeClosingData } from '~/store/modules/EdicaoOperacao/Turno/actions';

import * as S from './styles';

export default function Closing({ data, editable, loading }) {
  const dispatch = useDispatch();

  const handleChangeValueInput = useCallback(({ key, value }) => {
    dispatch(changeClosingData(key, value));
  }, []);

  return (
    <S.WrapperTabela>
      {loading && <LinearProgress />}

      <S.WrapperTitle>
        <Typography>{t('s.configuracao.bico.encerrantebico')}</Typography>
      </S.WrapperTitle>

      <TableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell variant="head">
                {t('s.relatorio.diferencaencerrante.idbico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.configuracao.medidor.descricaomedidor')}
              </TableCell>
              <TableCell variant="head">
                {t('s.geral.camposistema.encerranteinicialmovimentacao')}
              </TableCell>
              <TableCell variant="head">
                {t('s.geral.camposistema.encerrantefinalmovimentacao')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, key) => (
              <TableRow key={key}>
                <TableCell variant="body">{row.idbico}</TableCell>
                <TableCell variant="body">{row.nomeabreviadoproduto}</TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      type="number"
                      value={row.mecanicoinicioturnobico}
                      onChange={({ target }) =>
                        handleChangeValueInput({
                          key,
                          value: {
                            ...row,
                            mecanicoinicioturnobico: parseFloat(target.value),
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.mecanicoinicioturnobico, 2)
                  )}
                </TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      type="number"
                      value={row.mecanicofimturnobico}
                      onChange={({ target }) =>
                        handleChangeValueInput({
                          key,
                          value: {
                            ...row,
                            mecanicofimturnobico: parseFloat(target.value),
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.mecanicofimturnobico, 2)
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Closing.propTypes = {
  editable: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      idbico: PropTypes.string.isRequired,
      nomeabreviadoproduto: PropTypes.string.isRequired,
      mecanicoinicioturnobico: PropTypes.string.isRequired,
      mecanicofimturnobico: PropTypes.string.isRequired,
    })
  ).isRequired,
};

Closing.defaultProps = {
  editable: false,
  loading: false,
};
